/**
 * @generated SignedSource<<c6b33e29a865ea2ab8391a53419a96f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_item$data = {
  readonly popularSearchesLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
  };
  readonly " $fragmentType": "SharedRespLinksBlock_item";
};
export type SharedRespLinksBlock_item$key = {
  readonly " $data"?: SharedRespLinksBlock_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3df590818322d1a95955cbda2b44bf7a";

export default node;
